export default `{
      lots {
        applicationRowsKey {
          headerId
          rowsIds
        }
        lotId
        lotNumber
        nomenclatureId
        lotSubject
        quantity
        minimalSubmitQuantity
        bidPriceLimit
        measuringUnit
        startAmount
        discounts {
          quantity
          price
        }
        bidStep
        description
        addressId
        additionalFieldValues {
          valueId
          fieldId
          entityKey
          value
          order
        }
      }
      tenderId
      tenderNumber
      tenderStatusId
      organizerName
      tenderPublishedSchedule {
        contactId
        scheduledDate
        isScheduled
      }
      hasRoute
      applicationBased
      additionalContactPersons {
        contactId
        name
        phone
        email
      }
      contactPersonId
      testMode
      criteryCard
      bidStepType
      hideBestPrice
      publicTenderResults
      requiedAttachments
      bidOnAllLots
      mandatoryFullBid
      allowRaising
      areIndividualsAllowed
      vat
      currencyOwner
      tenderCurrency
      allowedCurrencies
      prolongRuleCode
      biddingType {
        biddingTypeId
        titleRu
        oldCode
        isSale
        isPublic
        initialRateAvailable
        bidStepAvailable
        prolongationRuleAvailable
        reducedPriceAvailable
        isRating
        isAnalysisMarket
        analogAvailable
        allowRaising
        tenderingForPercentage
        isMultistage
        isFrameAuction
        isFrameFirstStage
        showSubscribedUsers
        allowCreation
        withoutPublication
        allowCounterOffer
        allowPriceRequest
        recalcTotalSummByReducedPrice
        onlyOneLotPerTender
        minimalQuantity
        saleWithDiscount
        saleInParts
        multipleRoundsOnAuction
        hideBidderInfoBeforeEndForSupplier
        automaticQualification
        hideBidderInfoOnPrequalification
        hideBidderInfoOnTendering
        bidStepFromSelfLastPrice
        canChangeCurrencyOwner
        groupedLotsEnabled
        groupedLotsEnabled
        allowedCurrenciesSelectionByOrganizer
        paidCommercialBidding
      }
      bidOnAllLotInGroup
      tenderDescription
      tenderSubject
      classificationCode
      deliveryPeriodTo
      deliveryPeriodFrom
      tenderPeriodTo
      scheduledStart
      createdByExternalApi
      tenderProlongationRules {
        ruleId
      }
      isUrgent
      allowParticipantBidCancellation
      inviteFilter
      allowedCurrencies
      lotGroups {
        id
        title
        description
        innerLotIds
      }
    }`